import { registerNotificationKind } from '../registry.js';
/**
 * Module 70's notification kinds (spec 70 §4.7, S70-2, REQ-70-003/004):
 * `data.account_id`, `data.content_title` (display name for the account,
 * reusing the generic mail/in-app placeholder every kind fills) and
 * `data.platform` are always present. All three link to the accounts page,
 * where the account's own status pill already shows the detail (S70-1).
 */
export const SOCIAL_ACCOUNT_EXPIRING = 'social_account_expiring';
export const SOCIAL_ACCOUNT_EXPIRED = 'social_account_expired';
export const SOCIAL_ACCOUNT_REVOKED = 'social_account_revoked';
registerNotificationKind({
    kind: SOCIAL_ACCOUNT_EXPIRING,
    i18nKey: 'notifications.kind.social_account_expiring',
    mailTemplate: 'social_account_expiring',
    linkTarget: () => '/settings/accounts',
});
registerNotificationKind({
    kind: SOCIAL_ACCOUNT_EXPIRED,
    i18nKey: 'notifications.kind.social_account_expired',
    mailTemplate: 'social_account_expired',
    linkTarget: () => '/settings/accounts',
});
registerNotificationKind({
    kind: SOCIAL_ACCOUNT_REVOKED,
    i18nKey: 'notifications.kind.social_account_revoked',
    mailTemplate: 'social_account_revoked',
    linkTarget: () => '/settings/accounts',
});
/**
 * A publication failed for good (spec 70 §4.7, REQ-70-016, AC-70-040):
 * `data.publication_id`, `data.content_item_id`, `data.content_title`,
 * `data.platform`, `data.error_code`, `data.scheduled_at`. Recipients: users
 * with `publications:write`; `dedupe_key` `publication_failed:<id>:<attempt_no>`.
 * Links to the publication detail panel (spec 70 §6.3, route added S70-6).
 */
export const PUBLICATION_FAILED = 'publication_failed';
registerNotificationKind({
    kind: PUBLICATION_FAILED,
    i18nKey: 'notifications.kind.publication_failed',
    mailTemplate: 'publication_failed',
    linkTarget: (data) => `/publications/${String(data.publication_id)}`,
});
/**
 * A publication is still not published `PUBLISH_LATE_AFTER_SECONDS` after its
 * scheduled time (spec 70 §4.7, REQ-70-015, AC-70-039): `data.publication_id`,
 * `data.content_item_id`, `data.content_title`, `data.platform`,
 * `data.scheduled_at`. Recipients: users with `publications:write`;
 * `dedupe_key` `publication_late:<id>:<scheduled_at>` — the check runs every
 * minute but sends once per `scheduled_at`, even across a later reschedule
 * that keeps the same time. Links to the publication detail panel (spec 70 §6.3).
 */
export const PUBLICATION_LATE = 'publication_late';
registerNotificationKind({
    kind: PUBLICATION_LATE,
    i18nKey: 'notifications.kind.publication_late',
    mailTemplate: 'publication_late',
    linkTarget: (data) => `/publications/${String(data.publication_id)}`,
});
//# sourceMappingURL=publishing.js.map